import { useMutation } from '@tanstack/react-query'
import { postContact } from 'services/ContactService'

export const usePostContactMutation = () => {
  return useMutation({ mutationFn: postContact })
}
